var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7158,
    cy: 28.2843,
    r: 19.5,
    transform: "rotate(-135 28.7158 28.2843)",
    fill: "#FBFAFF",
    stroke: "#027496"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9448 24.5132L24.9448 25.8426L30.2104 25.8473L24.4734 31.5843L25.4162 32.5271L31.1532 26.7901L31.1579 32.0557L32.4873 32.0557L32.4873 24.5132L24.9448 24.5132Z",
    fill: "#027496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.4f406be7f450f760ec940218d060c43b.svg";
export { ForwardRef as ReactComponent };